// Front
export * from "./layouts/thunk";

// Authentication
export * from "./auth/login/thunk";
export * from "./auth/profile/thunk";


// File Manager
export * from "./fileManager/thunk"


// Import the new actions
import {
    getKAudiencesSessionsChartsData as getKAudiencesSessionsChartsDataAction,
    dashboardApiResponseSuccess,
    dashboardApiResponseError,
    getKStoreVisitsData as getKStoreVisitsDataAction,
    getUserGrowth
} from "./kdashboard/action";

// Import the data from Kdashboard
import {
    kTodayAudiencesCountryData,
    kLastWeekAudiencesCountryData,
    kLastMonthAudiencesCountryData,
    kCurrentYearAudiencesCountryData
} from "../common/data/Kdashboard";

// Import the API helpers
import {
    getKTodaySessionData,
    getKLastWeekSessionData,
    getKLastMonthSessionData,
    getKCurrentYearSessionData,
    postKUserSessionsData
} from "../helpers/fakebackend_helper";

// Import the action type
import {
    GET_K_AUDIENCES_SESSIONS_CHARTS_DATA,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
    GET_K_STORE_VISITS_DATA,
    GET_USER_GROWTH_DATA
} from "./kdashboard/actionType";

// Add new thunk
export const getKAudiencesSessionsChartsData = (periodType) => async (dispatch) => {
    try {
        dispatch(getKAudiencesSessionsChartsDataAction(periodType));
        const response = await postKUserSessionsData(periodType);
        if (response && response.data) {
            dispatch(dashboardApiResponseSuccess(GET_K_AUDIENCES_SESSIONS_CHARTS_DATA, response.data));
        } else {
            throw new Error("No data in response");
        }
    } catch (error) {
        const serializedError = {
            message: error.message || 'An error occurred',
            code: error.code || 'ERROR',
            status: error.response?.status || 500
        };
        dispatch(dashboardApiResponseError(GET_K_AUDIENCES_SESSIONS_CHARTS_DATA, serializedError));
    }
};

export const getKStoreVisitsData = () => async (dispatch) => {
    try {
        dispatch(getKStoreVisitsDataAction());
        
        // Mock data for store visits
        const mockResponse = {
            data: [
                {
                    name: "Direct",
                    data: [10, 36, 12, 44, 33, 24, 54, 43, 63, 29, 41, 38]
                },
                {
                    name: "Organic",
                    data: [52, 43, 35, 27, 43, 64, 52, 41, 48, 53, 39, 42]
                },
                {
                    name: "Referral",
                    data: [22, 31, 36, 26, 47, 56, 42, 64, 43, 45, 53, 58]
                },
                {
                    name: "Campaign",
                    data: [26, 43, 48, 53, 33, 44, 56, 52, 34, 47, 54, 45]
                }
            ]
        };

        dispatch(dashboardApiResponseSuccess(GET_K_STORE_VISITS_DATA, mockResponse.data));
    } catch (error) {
        const serializedError = {
            message: error.message || 'An error occurred',
            code: error.code || 'ERROR',
            status: error.response?.status || 500
        };
        dispatch(dashboardApiResponseError(GET_K_STORE_VISITS_DATA, serializedError));
    }
};

// Add Revenue Charts thunk
export const getRevenueChartsData = (periodType) => async (dispatch) => {
    try {
        // Mock data for revenue charts
        const mockResponse = {
            data: {
                revenue: [10, 36, 12, 44, 33, 24, 54, 43, 63, 29, 41, 38],
                growth: [52, 43, 35, 27, 43, 64, 52, 41, 48, 53, 39, 42]
            }
        };
        
        dispatch({
            type: 'GET_REVENUE_CHARTS_DATA',
            payload: mockResponse.data
        });
    } catch (error) {
        console.error('Error fetching revenue data:', error);
    }
};

export const getUserGrowthData = (timeRange) => async (dispatch) => {
    try {
        // Sample data generation based on timeRange
        const now = new Date();
        const data = {
            timestamps: [],
            totalUsers: [],
            newUsers: [],
            activeUsers: []
        };

        let points = 0;
        let interval = 0;

        switch(timeRange) {
            case 'today':
                points = 24;
                interval = 60 * 60 * 1000; // 1 hour
                break;
            case 'week':
                points = 7;
                interval = 24 * 60 * 60 * 1000; // 1 day
                break;
            case 'month':
                points = 30;
                interval = 24 * 60 * 60 * 1000; // 1 day
                break;
            case 'year':
                points = 12;
                interval = 30 * 24 * 60 * 60 * 1000; // ~1 month
                break;
            default:
                points = 24;
                interval = 60 * 60 * 1000;
        }

        // Generate sample data
        for(let i = points - 1; i >= 0; i--) {
            const timestamp = new Date(now - (i * interval));
            data.timestamps.push(timestamp.toISOString());
            data.totalUsers.push(Math.floor(180000 + Math.random() * 10000));
            data.newUsers.push(Math.floor(100 + Math.random() * 500));
            data.activeUsers.push(Math.floor(50000 + Math.random() * 5000));
        }

        // In real implementation, this would be an API call
        // const response = await APIClient.get(`${config.api.API_URL}/dashboard/user-growth?timeRange=${timeRange}`);
        // const data = response.data;

        return dispatch({
            type: GET_USER_GROWTH_DATA,
            payload: data
        });
    } catch (error) {
        console.error('Error fetching user growth data:', error);
        return error;
    }
}; 